module.exports = __webpack_public_path__ + "a325a4052a88276ba407d38efb136077.png";